"use strict";

$(function () {
  "use strict";

  $(document).on("click", ".sidebar a.toggleNavigation", toggleNavigation);
  $(document).on("click", ".sidebar ul.childToggleNavigation", childToggleNavigation);

  function toggleNavigation() {
    var $this = $(this),
        $sibling = $this.siblings("ul");

    //mobile
    if ($sibling.css("position") == "absolute") {
      hideOthers();
      $sibling.toggle();
    } else {
      $sibling.slideToggle();
    }
  }

  function childToggleNavigation() {
    var $this = $(this);
    if ($this.css("position") == "absolute") {
      $this.toggle();
    }
  }

  function hideOthers() {
    $('.sidebar a.toggleNavigation').each(function (i, v) {
      var $this = $(this),
          $sibling = $this.siblings("ul");

      if ($sibling.css('display') == 'block') {
        $sibling.toggle();
      }
    });
  }
});


// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.toggle.js